module.exports = __webpack_public_path__ + "flyer_background_wreath_047-299d3aa8ce4bd7a3c20d7cec255717c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_wreath_047.jpg
// module id = 1707
// module chunks = 1